import { Skeleton } from '~/src/common/components/Skeleton/Skeleton';

import * as S from './layout';

export const RecipeScreenSkeleton = () => (
  <S.Root role="progressbar">
    <Skeleton width="60%" height={16} />

    <S.Content>
      <S.Grid>
        <S.NameAndTag>
          <Skeleton width={40} height={24} />
          <Skeleton width={300} />
        </S.NameAndTag>

        <S.Image height="calc(100vw - 32px)" />

        <S.PreparationInfos>
          <Skeleton width={72} height={60} />
          <Skeleton width={72} height={60} />
          <Skeleton width={72} height={60} />
          <Skeleton width={72} height={60} />
        </S.PreparationInfos>

        <S.Picker>
          <Skeleton height={24} width={134} />
          <Skeleton height={40} width={208} />
        </S.Picker>

        <S.ShortDescription>
          <Skeleton />
          <Skeleton width={100} />
        </S.ShortDescription>
      </S.Grid>

      <S.ProductInformation>
        <Skeleton width={90} />
        <Skeleton height={300} />
      </S.ProductInformation>

      <S.AdditionalInformation>
        <Skeleton width={150} />
        <Skeleton height={600} />
      </S.AdditionalInformation>
    </S.Content>
  </S.Root>
);
